// extracted by mini-css-extract-plugin
var _1 = "FileDragOverlay-modulewrapper__eVtXA";
export { _1 as "wrapper" }
